import React from 'react';
import { Button } from 'antd';
import { t } from 'helpers/i18n';
import './SilenceLoginUncompleted.scss';
import { clearAuthConfig } from 'helpers/auth';

const SilenceLoginUncompleted: React.FC = () => {
  const retryLogin = () => {
    clearAuthConfig();
    // reload page to trigger login flow again
    window.location.reload();
  };

  return (
    <div className="silence-login-uncompleted-container">
      <p className="silence-login-uncompleted-description">
        {t('silence_login_uncompleted_description')}
      </p>
      <Button
        className="silence-login-uncompleted-retry-button"
        type="primary"
        ghost={true}
        onClick={retryLogin}
      >
        {t('Retry')}
      </Button>
    </div>
  );
};

export default SilenceLoginUncompleted;
